import { ReactNode } from 'react'

const InputHint = ({ children }: { children: ReactNode }) => (
  <div className="InputHint">{children}</div>
)

export default InputHint
